/**
 * @author wangjunfeng
 */

import Aside from './sy-aside'
export default Aside
